export function isValidGameCode () {
  if (window.location.href.indexOf('signup') !== -1 ||
    window.location.href.indexOf('activate-account') !== -1 ||
    window.location.href.indexOf('disable-notification') !== -1 ||
    window.location.href.indexOf('clicked-notification') !== -1
  ) {
    return false
  }

  return (window.location.pathname !== '/' &&
    window.location.pathname !== '/login' &&
    window.location.pathname !== '/signup' &&
    window.location.pathname !== '/new-password' &&
    window.location.pathname !== '/change-nickname' &&
    window.location.pathname !== '/404' &&
    window.location.pathname !== '/403' &&
    window.location.pathname !== '/logout' &&
    window.location.pathname !== '/clear' &&
    window.location.pathname !== '/mission' &&
    window.location.pathname !== '/greetings' &&
    window.location.pathname !== '/esqueci-minha-senha' &&
    window.location.pathname !== '/instructions' &&
    window.location.pathname !== '/approval-instructions' &&
    window.location.pathname !== '/sair' &&
    window.location.pathname !== '/home-lobby' &&
    window.location.pathname !== '/game-not-found')
}
